// SearchComponent.js (React)

import React, { useState, useEffect, useContext } from "react";
import PlaylistTile from "./PlaylistTile";
import CurrentPlaylistContext from "../contexts/CurrentPlaylistContext";
import ArtistTileCatalog from "./ArtistTileCatalog";
import { playlistsAPI, normalizeText } from "../services/supabaseClient";

const SearchComponent = (props) => {
  const [searchTerm, setSearchTerm] = useState("");
  const [searchResults, setSearchResults] = useState([
    { playlists: [], videos: [] },
  ]);
  // eslint-disable-next-line no-unused-vars
  const [isSearching, setIsSearching] = useState(false);

  const {
    currentPlaylist,
    setCurrentPlaylist,
    searchVideo,
  } = useContext(CurrentPlaylistContext);

  const debounce = (fn, delay) => {
    let timer;
    return function (...args) {
      clearTimeout(timer);
      timer = setTimeout(() => {
        fn(...args);
      }, delay);
    };
  };

  const handleSearch = debounce(async () => {
    try {
      setIsSearching(true);

      // Search for videos
      const videos = await playlistsAPI.searchVideos(searchTerm);

      // Search for playlists/artists using normalized text
      const allPlaylists = await playlistsAPI.getAll();
      const normalizedSearchTerm = normalizeText(searchTerm);
      const playlists = allPlaylists.filter((playlist) =>
        normalizeText(playlist.name).includes(normalizedSearchTerm)
      );

      setSearchResults({ playlists, videos });
    } catch (error) {
      console.error("Error fetching search results:", error);
      setSearchResults({ playlists: [], videos: [] });
    } finally {
      setIsSearching(false);
    }
  }, 300);

  useEffect(() => {
    if (searchTerm.length < 3) {
      setSearchResults([{ playlists: [], videos: [] }]);
      return;
    }
    handleSearch();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchTerm]);

  const onTileClickHandler = (video) => {
    console.log(video);
    if (currentPlaylist !== video.playlist_id) {
      setCurrentPlaylist(video.playlist_id);
      searchVideo(video.playlist_id, video.id);
    } else searchVideo(video.playlist_id, video.id);
    setSearchTerm("");
    setSearchResults([]);
    props.onSongSelected();
  };

  const onArtistTileClickHandler = (artist) => {
    console.log(artist);
    if (currentPlaylist !== artist.id) {
      setCurrentPlaylist(artist.id);
      searchVideo(artist.id, artist.id);
    } else searchVideo(artist.id, artist.id);
  };

  return (
    <div className="search-bar">
      {/* {isSearching && <p>Searching...</p>} */}
      {/* {searchResults.map((video) => (
          <li key={video.id}>{video.title}</li>
        ))} */}

      <div className="container-search">
        <form className="form-inline search-bar-field">
          <div className="search-input-wrapper">
            <i className="fas fa-search search-input-icon"></i>
            <input
              className="form-control mr-sm-2 search-bar"
              type="search"
              value={searchTerm}
              placeholder="Zadejte název interpreta nebo skladby"
              onChange={(e) => setSearchTerm(e.target.value)}
              aria-label="Search"
            />
          </div>
        </form>
        <div className="results">
          <ul>
            {searchTerm.length > 2 &&
              searchResults.playlists?.length > 0 &&
              searchResults.playlists?.map((artist, index) => (
                <li key={artist.id}>
                  <ArtistTileCatalog
                    key={index}
                    artist={artist}
                    onClick={onArtistTileClickHandler}
                  />
                </li>
              ))}
            {searchTerm.length > 2 &&
              searchResults.videos?.length > 0 &&
              searchResults.videos?.map((video, index) => (
                <li key={video.id}>
                  <PlaylistTile
                    key={index}
                    video={video}
                    showArtist={true}
                    index={video.id}
                    onClick={onTileClickHandler}
                  />
                </li>
              ))}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default SearchComponent;
